import { createBrowserHistory, createHashHistory } from 'history';

export default function configHistory() {

	//alert('hello world kub');

    return window.matchMedia('(display-mode: standalone)').matches
        ? createHashHistory()
        : createBrowserHistory()
}


